import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('LegalEntityPerimeterDA', LegalEntityPerimeterDA);

    LegalEntityPerimeterDA.$inject = ['Restangular', 'CONF'];

    /**
     * Class permettant la manipulation des infos realtives aux périmètres d'une société.
     */

    /* @ngInject */
    function LegalEntityPerimeterDA(Restangular, CONF) {
        var baseUrl = CONF.apiBaseUrl + '/v1/legal-entity-perimeter';

        var exports = {
            updatePerimeter,
            deletePerimeter,
            checkPerimeterDeletion,
        };

        return exports;

        ////////////////
        /**
         * Ajout/Modififcation du périmètre de la société.
         */
        function updatePerimeter(legalEntityId, legalEntityPerimeter) {
            return Restangular.one(baseUrl, legalEntityId).customPOST(legalEntityPerimeter);
        }

        /**
         * Suppression du périmètre de la société
         */
        function deletePerimeter(legalEntityId, legalEntityPerimeterCode) {
            return Restangular.one(baseUrl, legalEntityId).one('perimeterToDelete', legalEntityPerimeterCode).remove();
        }

        /**
         * Vérification possibilité de suppression du périmètre
         */
        function checkPerimeterDeletion(legalEntityId, legalEntityPerimeterCode) {
            return Restangular.one(baseUrl, legalEntityId).one('perimeterToCheck', legalEntityPerimeterCode).get();
        }
    }
})();
